<template>
  <div
    ref="rootRef"
    class="transfer-transport-types gap-8 hide-scrollbar flex"
  >
    <template
      v-for="{ id, delivery } in configs.transport_types"
      :key="id"
    >
      <TransportTypeTile
        v-if="!delivery"
        :model-value="modelValue"
        :type="id"
        :price="route.prices && route.prices[id]"
        @update:modelValue="$emit('update:modelValue', $event)"
      />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useQuasar } from 'quasar';
import { storeToRefs } from 'pinia';

import TransportTypeTile from '~components/TransportTypeTile';

import { useConfigsStore } from '~stores/configs';

const configsStore = useConfigsStore();
const { configs } = storeToRefs(configsStore);

const $q = useQuasar();

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  route: {
    type: Object,
    required: true,
  },
});

defineEmits(['update:modelValue']);

const rootRef = ref(null);

onMounted(() => {
  nextTick(() => {
    if ($q.screen.lt.sm && props.modelValue.length) {
      rootRef.value.scrollLeft = rootRef.value.querySelector('.q-card.checked').offsetLeft - 16;
    }
  });
});
</script>

<style lang="scss" scoped>
@media screen and (max-width: $breakpoint-sm-max){
  .transfer-transport-types {
    overflow: auto;
    flex-wrap: nowrap;
    margin: 0 -16px;

    .tile {
      &:first-child {
        margin-left: 16px;
      }

      &:last-child {
        margin-right: 16px;
      }
    }
  }
}
</style>
